<template>
  <div>
    <!-- {{ dateRange }} -->
    <d-table
      :data_object="data_object"
      :getFreshData="true"
      :alwaysUpdate="false"
      :editRow="false"
      :hasSearch="true"
      :searchLen="3"
      :noCache="true"
      :defaultModel="defaultModel"
      :fields_excluded="fields_excluded"
      :onDataReceived="onDataReceived"
      :hideAllTabFilter="true"
      table_title="Reports"
      :noDelete="true"
      ref="table"
      :actionCommand="actionCommand"
      :link="link"
      :linkClick="linkClick"
      :toolBarControls="toolBarControls"
      v-if="tableReady"
      :directEdit="false"
      :editable="editable"
    />
    <v-alert
      class="ma-4"
      timeout="3000"
      dismissible
      v-if="errorMessage != '' && errorMessage"
      type="error"
    >
      {{ errorMessage }}
    </v-alert>
  </div>
</template>

<script>
import axios from "axios";

import DTable from "../components/Table";
import * as fun from "../plugins/common";

export default {
  name: "Reports",
  components: { DTable },
  data: () => ({
    tableReady: false,
    fields_excluded: [],
    fieldsData: {
      object_name: "v_shipment_letter_fields",
    },
    data_object: {
      object_name: "reports",
      defaultModel: { type: "report" },
      noCache: true,
      all_records: true,
      table_title: "reports",
      additional_structure: [
        {
          obj_name: "v_shipment_letter_fields",
        },
        {
          obj_name: "v_trip",
        },
        {
          obj_name: "employee",
        },
        {
          obj_name: "storage",
        },
      ],
    },
    link: {
      field: "_id",
      name: "report",
      // params: { qry: props.item[link.field] },
    },
    actionCommand: [
      {
        icon: "mdi-book-open",
        text: "View Report",
        color: "primary",
      },
      // {
      //   icon: "mdi-file-excel",
      //   text: "Excel",
      //   color: "success",
      // },
      // {
      //   icon: "mdi-language-html5",
      //   text: "HTML",
      //   color: "warning",
      // },
    ],
    dateRange: null,
    errorMessage: "",
    toolBarControls: [
      {
        comp: "v-date-range-picker",
        default: true,

        id: "date_range",
        "v-bind": { label: "Date Range", alwaysOnTop: true },
      },
    ],
    editable: ["dates"],
  }),

  mounted() {
    this.actionCommand.forEach((a) => {
      a.action = this.linkClick;
    });
    var d = new Date();
    var range = [];
    // range.push("1/"+d.getMonth()+1+"/"+d.getFullYear())
    var month = d.getMonth() + 1;
    this.dateRange =
      month +
      "/" +
      "1/" +
      d.getFullYear() +
      " - " +
      month +
      "/" +
      d.getDate() +
      "/" +
      d.getFullYear();
    this.toolBarControls[0]["v-bind"].dateChange = this.dateChange;
    this.toolBarControls[0]["v-bind"].vModel = this.dateRange;
    this.tableReady = true;
  },

  methods: {
    onDataReceived(d) {
      console.log(d);
      var dates = [];

      var serviceProperties =
        d.additional_structure.v_shipment_letter_fields.properties.service
          .properties;
      var shipmentDetailProperties =
        d.additional_structure.v_shipment_letter_fields.properties
          .shipment_detail.properties;
      // Object.keys(d.additional_structure).forEach((p) => {
      //   if (p != "v_shipment_letter_fields") {
      //     serviceProperties = {
      //       ...serviceProperties,
      //       ...d.additional_structure[p].properties,
      //     };
      //   }
      // });

      // Object.keys(serviceProperties).forEach((p) => {
      //   if (p.includes("_date") || p == "etd" || p == "eta") {
      //     dates.push(p);
      //   }
      // });
      Object.keys(d.additional_structure).forEach((s) => {
        // if (s != "v_shipment_letter_fields") {
        serviceProperties = {
          ...serviceProperties,
          ...d.additional_structure[s].properties,
        };
        Object.keys(serviceProperties).forEach((p) => {
          if (p.includes("_date") || p == "etd" || p == "eta") {
            dates.push({ p, s });
          }
        });
        Object.keys(shipmentDetailProperties).forEach((p) => {
          if (p.includes("_date")) {
            dates.push({ p, s });
          }
        });
        // }
      });
      console.log(dates);
      d.schema.properties.dates["v-bind"].items = dates;
      // d.model.forEach((m) => {
      //   m.dates = dates[0];
      // });
      return d;
    },
    dateChange(dateRange) {
      // console.log(this.$refs.date_range);
      var r = this.$refs.table.$refs.date_range;
      r[0].menu = false;

      this.dateRange = dateRange;
    },
    createDateQry(item) {
      var dates = this.dateRange.split("-");
      var prefix = "";
      if (item.parent == "v_shipment_letter_fields") {
        prefix = item.dates == "order_date_time" ? "" : "service.";
      }
      var qry = {
        dateField: prefix + item.dates,
        dates: dates,
      };
      // var dateField = "service." + item.dates;
      // qry[dateField] = {
      //   $gte: fun.formatDate(dates[0], true, null, true),
      //   $lt: fun.formatDate(dates[1], true, null, true),
      // };

      return qry;
    },
    linkClick(item) {
      this.errorMessage = "";
      if (!this.dateRange || this.dateRange.split("-").length != 2) {
        this.errorMessage = "Please select date range";
      } else {
        item.text = item.report_name;
        // item.report_type = "html";
        localStorage.setItem(
          "reportDatesQry",
          JSON.stringify(this.createDateQry(item))
        );
        // this.$root.reportDateQry = this.createDateQry(item);
        // item.qry = this.createDateQry(item);
        // item.icon = item.icon;
        this.$root.addResentTab(item);
      }
    },
  },
};
</script>

<style scoped></style>
